<template>
  <div class="text-xs">
    <v-dialog
      v-model="dialog"
      fullscreen
      transition="dialog-bottom-transition"
    >

      <template v-slot:activator="{ on }">
        <v-btn small text color="primary" v-on="on">
          <div>
            <v-icon dark left>create</v-icon>New Image
          </div>
        </v-btn>
      </template>

      <v-toolbar color="primary" dark dense>
        <v-btn icon dark @click.prevent="dialog = false">
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title>New Image</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn dark text @click.prevent="confirmImage()">Submit</v-btn>
        </v-toolbar-items>
      </v-toolbar>

      <v-card>
        <v-card-text>
          <v-container grid-list-md>

            <v-layout wrap>
              <v-flex md10>
                <v-radio-group v-model="deviceType" :mandatory="true" row>
                  <v-radio label="PAC" value="PAC"></v-radio>
                  <v-radio label="SCADA" value="SCADA"></v-radio>
                </v-radio-group>
              </v-flex>
              <v-spacer></v-spacer>
              <v-flex md2>
                <v-btn small text color="primary" @click.prevent="callRefreshPlants()">
                  <v-icon dark left>refresh</v-icon>Refresh Plants
                </v-btn>
              </v-flex>
            </v-layout>

            <v-layout wrap>
              <v-flex md12>
                <v-autocomplete
                  label="Plant"
                  v-model="plantfolder"
                  :loading="isLoading.plants"
                  :items="Object.keys(allPlants).sort()"
                  :search-input.sync="search"
                  hide-no-data
                  return-object
                  clearable
                ></v-autocomplete>
              </v-flex>
            </v-layout>

            <v-layout v-if="plantinfo">
              <v-flex md3>
                <v-chip class="ma-2" label>
                  Plant ID: {{ allPlants[plantfolder].plantid }}
                </v-chip>
              </v-flex>
              <v-flex md3>
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-chip class="ma-2" label v-on="on">
                      Total Devices: {{ plantinfo.deviceinfoList.length }}
                    </v-chip>
                  </template>
                  <span>
                    <ul>
                      <li v-for="v in plantinfo.deviceinfoList" :key="v.deviceid">{{ v.idx }} - {{ v.model }}</li>
                    </ul>
                  </span>
                </v-tooltip>
              </v-flex>
              <v-flex md3 v-if="unsupportedDevices.length > 0">
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-chip class="ma-2" label v-on="on">
                      Supported Devices: {{ supportedDevices.length }}
                    </v-chip>
                  </template>
                  <span>
                    <ul>
                      <li v-for="v in supportedDevices" :key="v.deviceid">{{ v.idx }} - {{ v.model }}</li>
                    </ul>
                  </span>
                </v-tooltip>
              </v-flex>
              <v-flex md3 v-if="unsupportedDevices.length > 0">
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-chip class="ma-2" label color="red" text-color="white" v-on="on">
                      Unsupported Devices: {{ unsupportedDevices.length }}
                    </v-chip>
                  </template>
                  <span>
                    <ul>
                      <li v-for="v in unsupportedDevices" :key="v.deviceid">{{ v.idx }} - {{ v.model }}</li>
                    </ul>
                  </span>
                </v-tooltip>
              </v-flex>
              <v-flex md3 v-if="template">
                <v-chip class="ma-2" label>
                  OS: {{ template.os }}
                </v-chip>
              </v-flex>
              <v-flex md6 v-if="template">
                <v-chip class="ma-2" label>
                  Base Image: {{ template.baseimage }}
                </v-chip>
              </v-flex>
            </v-layout>

            <v-layout md12>
              <v-flex>
                <v-autocomplete
                  label="Template"
                  v-model="templateIdComposite"
                  :loading="isLoading.templates"
                  :items="getTemplates()"
                  :disabled="false"
                  hide-no-data
                  return-object
                ></v-autocomplete>
              </v-flex>
            </v-layout>

            <v-flex md12>
              <div v-if="template" style="color:#757575">
                {{ template.description }}
              </div>
            </v-flex>

            <v-layout wrap v-if="deviceType=='PAC'">
             <v-flex md6>
                <v-checkbox
                  v-model="coldStandby"
                  :disabled="!plantfolder"
                  label="Use last known configuration"
                  hint="Select a plant for last known configuration"
                  :persistent-hint="!plantinfo"
                ></v-checkbox>
                <div v-if="!plantinfo">
                  
                </div>
                <div v-if="coldStandby && agentState">
                  Last known configuration is from {{ dateToString(agentState.lastseen) }}. <br />
                  Current plant status is
                  <span style="color:green" v-if='agentState.status == "Registered"'>{{ agentState.status }}</span>
                  <span style="color:red" v-else-if='agentState.status == "Offline"'>{{ agentState.status }}</span>
                  <span style="color:green" v-else-if='agentState.status == "RegisteredRedundant"'>{{ agentState.status }}</span>
                  <span style="color:orange" v-else-if='agentState.status == "RegisteredConflict"'>{{ agentState.status }}</span>
                  <span style="color:orange" v-else-if='agentState.status == "RegisteredDegraded"'>{{ agentState.status }}</span>
                  <span v-else>{{ agentState.status }}</span>
                </div>
              </v-flex>
              <v-spacer></v-spacer>
              <v-flex md2>
                <v-text-field
                  v-model="tel3Version"
                  label="TEL3/OS Version"
                  persistent-hint
                  :disabled="false"
                ></v-text-field>
              </v-flex>
              <v-flex md2>
                <v-text-field
                  v-model="cprocVersion"
                  label="CPROC Version"
                  persistent-hint
                  :disabled="false"
                ></v-text-field>
              </v-flex>
            </v-layout> <!--PAC-->

            <v-layout>
               <v-flex md3>
                <v-checkbox
                  v-model="remotemanagement"
                  label="Remote Management"
                  hint="Installs CoolAgent"
                  persistent-hint
                ></v-checkbox>
              </v-flex>
              <v-flex md3>
                <v-checkbox
                  v-model="remoteaccess"
                  label="Remote Access"
                  hint="Via reverse ssh"
                  persistent-hint
                  v-if="aaaaccess(user)"
                ></v-checkbox>
              </v-flex>
              <v-flex md2 v-if="remoteaccess">
                <v-text-field
                  v-model.number="remoteaccessport"
                  type="number"
                  label="Port"
                  hint="Devices will be assigned an incremental port starting from this. Make sure they are available if specified else a random one will be assinged for each device."
                  persistent-hint
                  v-if="aaaaccess(user)"
                ></v-text-field>
              </v-flex>
            </v-layout>
            
            <v-layout>
               <v-flex md3>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-checkbox
                      v-model="optWantUpdates"
                      label="OS Updates"
                      hint="Produce an updated image"
                      persistent-hint
                    ></v-checkbox>
                   </template>
                   <span>It may take a bit longer now but would require less time to update after installing.</span>
                </v-tooltip>
              </v-flex>
            </v-layout>
            

           </v-container>
        </v-card-text>
      </v-card>

    <v-dialog
      v-model="confirmDialog"
      hide-overlay
      persistent
      width="600"
      v-if="confirmDialog"
    >
      <v-card>
        <v-card-title></v-card-title>
        <v-card-text>
          <v-simple-table dense>
            <tbody>
              <tr>
                <td style="white-space: nowrap">Plant Folder</td>
                <td>{{ plantfolder }}</td>
              </tr>
              <tr>
                <td style="white-space: nowrap">Plant ID</td>
                <td>{{ allPlants[plantfolder].plantid }}</td>
              </tr>
              <tr>
                <td style="white-space: nowrap">Site ID</td>
                <td>{{ allPlants[plantfolder].siteid }}</td>
              </tr>
              <tr>
                <td style="white-space: nowrap">Template ID</td>
                <td>{{ templateIdComposite.split(" ")[0] }}</td>
              </tr>
              <tr>
                <td>OS</td>
                <td>{{ template.os }}</td>
              </tr>
              <tr>
                <td style="white-space: nowrap">Base Image</td>
                <td>{{ template.baseimage }}</td>
              </tr>
              <tr>
                <td>Devices</td>
                <td>{{ supportedDevices.length }}</td>
              </tr>
              <tr>
                <td style="white-space: nowrap">Software Versions</td>
                <td v-if="getCustomPackages().length == 0">latest</td>
                <td v-else>{{ prettyPackages(getCustomPackages()) }}</td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-card-text>
        <v-card-text v-if="unsupportedDevices.length > 0">
           <div style="color:red">
             There are {{ unsupportedDevices.length }} plant devices that cannot be used by this template!
           </div>
           <div>
             If those devices are supported by another template, you can create additional images using supported templates.
           </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="confirmDialog = false;">Cancel</v-btn>
          <v-btn text color="primary" @click="confirmDialog = false; callNewImage()">Confirm</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="progressDialog"
      persistent
      width="500"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          Please stand by
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-snackbar
      v-model="snack"
      :color="snackColor"
      :timeout="snackTimeout"
      :top="true"
    >
      {{ snackMessage }}
      <v-btn
        text
        @click="snack = false"
      >
        <div class="v-menu__content--active" style="display:none; z-index:1000;"></div>
        Close
      </v-btn>
    </v-snackbar>

    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import libvue from '@/lib/vue.js'

export default {
  mixins: [libvue],
  data () {
    return {
      deviceType: "PAC",
      plantfolder: null,
      plantinfo: null,
      template: null,
      customPackages: false,
      coldStandby: false,
      tel3Version: 'latest',
      cprocVersion: 'latest',
      search: null,
      ctrlIDX: null,
      remotemanagement: true,
      remoteaccess: false,
      remoteaccessport: 0,
      agentState: null,
      dialog: false,
      progressDialog: false,
      confirmDialog: false,
      snack: false,
      snackColor: 'primary',
      snackMessage: '',
      snackTimeout: 1000,
      optWantUpdates: 0
    }
  },
  computed: {
    templateIdComposite: {
      get() {
        if (!this.plantinfo || !this.template) return null;
        return this.template.templateid + ' [' + this.deviceTypeToString(this.template.type) + '/' + this.template.os + '/' + this.template.baseimage + ']';
      },
      set(v) {
        this.updateTemplateIdComposite(v);
      }
    },
    supportedDevices: {
      get() {
        var sup = [];
        if (!this.plantinfo || !this.template) return sup;
        for (const device of this.plantinfo.deviceinfoList.filter((o) => o.supported)) {
          device.supportedbyList.forEach((di) => {
            if (di.templateid == this.template.templateid) {
              sup.push(device);
            }
          });
        }
        return sup;
      }
    },
    unsupportedDevices: {
      get() {
        var usup = [];
        if (!this.plantinfo || !this.template) return usup;
        for (const device of this.plantinfo.deviceinfoList) {
          if (!device.supported) {
            usup.push(device);
          } else {
            var found = false;
            device.supportedbyList.forEach((di) => {
              if (di.templateid == this.template.templateid) {
                found = true;
              }
            });
            if (!found) {
              usup.push(device);
            }
          }
        }
        return usup;
      }
    },
    ...mapGetters(['allPlants', 'allDevices', 'allTemplates', 'user', 'isLoading']),
  },
  watch: {
    deviceType: function() {
      this.template = null;
      this.templateIdComposite = null;
      this.plantinfo = null;
      this.coldStandby = false;
      this.callGetPlantInfo();
      if (this.coldStandby) {
        this.callGetAgentState();
      }
    },
    coldStandby: function(v) {
      if (v) {
        this.callGetAgentState();
      } else {
        this.tel3Version = 'latest';
        this.cprocVersion = 'latest';
      }
    },
    plantfolder: function(v) {
      this.template = null;
      this.templateIdComposite = null;
      this.plantinfo = null;
      this.coldStandby = false;
      if (!v) {
        return;
      }
      this.callGetPlantInfo();
      if (this.coldStandby) {
        this.callGetAgentState();
      }
    }
  },
  created() {
    this.filterPlants();
    this.filterDevices();
    this.filterTemplates();
  },
  methods: {
    callRefreshPlants() {
      this.progressDialog = true;
      this.refreshPlants().then(() => {
        this.progressDialog = false;
      }).catch(() => {
        this.progressDialog = false
        this.dialog = false;
      });
    },
    getDownloadURL() {
      return window.location.protocol+'//'+window.location.hostname+'/v1/'+this.imageID;
    },
    confirmImage() {
      if (!this.plantfolder) {
        this.snack = true;
        this.snackColor = 'error';
        this.snackMessage = "No plant was selected";
        return;
      }
      if (!this.template) {
        this.snack = true;
        this.snackColor = 'error';
        this.snackMessage = "No template was found";
        return;
      }
      if (!this.plantinfo) {
        this.snack = true;
        this.snackColor = 'error';
        this.snackMessage = "No plant informations was found";
        return;
      }
      if (this.supportedDevices.length == 0) {
        this.snack = true;
        this.snackColor = 'error';
        this.snackMessage = "No devices are supported for this plant";
        return;       
      }
      if (this.remoteaccess && !(this.remoteaccessport == 0 || (this.remoteaccessport > 1024 && this.remoteaccessport < 65356))) {
        this.snack = true;
        this.snackColor = 'error';
        this.snackMessage = "Port must be a number between 1024-65356 or 0";
        return;
      }
      this.confirmDialog = true;
    },
    callNewImage() {
      var im = {};
      // Type
      switch (this.deviceType) {
        // eslint-disable-next-line no-undef
        case this.deviceTypeToString(proto.pb.DeviceType.DEVICEPAC):
          // eslint-disable-next-line no-undef
          im.type = proto.pb.DeviceType.DEVICEPAC;
          break;
        // eslint-disable-next-line no-undef
        case this.deviceTypeToString(proto.pb.DeviceType.DEVICESCADA):
          // eslint-disable-next-line no-undef
          im.type = proto.pb.DeviceType.DEVICESCADA;
          break;
      }
      // PlantFolder
      im.plantfolder = this.plantfolder;
      // PlantID
      im.plantid = this.allPlants[this.plantfolder].plantid;
      // SiteID
      im.siteid = this.allPlants[this.plantfolder].siteid;
      // TemplateID
      im.templateid = this.template.templateid;
      // RemoteManagement
      im.remotemanagement = this.remotemanagement;
      // RemoteAccess
      im.remoteaccess = this.remoteaccess;
      im.remoteaccessport = this.remoteaccessport;
      // PackageVersions
      im.packageversionsList = this.getCustomPackages();
      // IDXs
      im.idxList = [];
      // OPTIONS for worker
      im.workerOptions = this.getWorkerOptions();

      this.supportedDevices.forEach((v) => {
        im.idxList.push(v.idx);
      });
      this.newImage(im);
      this.dialog = false;
    },
    getCustomPackages() {
      var packageversionsList = [];
      if (this.tel3Version != 'latest') {
        packageversionsList.push("tel3-"+this.tel3Version);
      }
      if (this.cprocVersion != 'latest') {
        packageversionsList.push("t3cproc-mqtt-"+this.cprocVersion);
      }
      return packageversionsList;
    },
    getWorkerOptions() {
      var workerOptions={}
      workerOptions.optWantUpdates=this.optWantUpdates
      return workerOptions;
    },
    getTemplates() {
      var templates = [];
      Object.values(this.allTemplates).forEach((o) => {
        if (this.deviceType == this.deviceTypeToString(o.type) && o.approved) {
          templates.push(o.templateid + ' [' + this.deviceTypeToString(o.type) + '/' + o.os + '/' + o.baseimage + ']');
        }
      });
      return templates;
    },
    callGetAgentState() {
      this.progressDialog = true;
      this.tel3Version = 'latest';
      this.cprocVersion = 'latest';
      this.getAgentState({"agentid": this.allPlants[this.plantfolder].ctrl0id}).then((as) => {
        var rx1 = /^tel3-[0-9.]+/;
        var rx2 = /^t3cproc-mqtt-[0-9.]+/;
        as.packagesList.forEach((p) => {
          if (p.match(rx1)) {
            this.tel3Version = p.split("tel3-")[1];
          }
          if (p.match(rx2)) {
            this.cprocVersion = p.split("t3cproc-mqtt-")[1];
          }
        });
        this.agentState = as;
        this.progressDialog = false;
      }).catch(() => {
        this.agentState = null;
        this.progressDialog = false;
        this.snack = true;
        this.snackColor = 'error';
        this.snackMessage = "Error getting information for current instance. You must enter a TEL3/OS version manually."
      });
    },
    callGetPlantInfo() {
      this.progressDialog = true;
      if (this.plantfolder) {
        var ctrl0id = this.allPlants[this.plantfolder].ctrl0id;
        // var plantfolder = this.plantfolder;
        this.getPlantInfo({"ctrl0id": ctrl0id, "plantfolder": this.plantfolder}).then((pi) => {
          // eslint-disable-next-line no-undef
          pi.deviceinfoList = pi.deviceinfoList.filter((o) => o.type == this.deviceStringToType(this.deviceType));
          // Find template id with most recent base image.
          var baseimage = "";
          var templateid = null;
          for (const di of pi.deviceinfoList.filter((o) => o.supported)) {
            for (const sup of di.supportedbyList) {
              if (baseimage < sup.baseimage) {
                baseimage = sup.baseimage;
                templateid = sup.templateid;
              }
            }
          }
          this.plantinfo = pi;
          if (templateid) {
            this.template = this.allTemplates[templateid];
          }
          this.progressDialog = false;
        }).catch((err) => {
          console.log(err)
          this.progressDialog = false;
          this.snack = true;
          this.snackColor = 'error';
          this.snackMessage = "Error getting information for current plant."
        });
      } else {
        this.plantinfo = null;
        this.progressDialog = false;
      }
    },
    updateTemplateIdComposite(v) {
      if (!v || !this.plantinfo) return;
      var templateid = v.split(" ")[0];
      this.template = this.allTemplates[templateid];
    },
    ...mapActions(['newImage', 'filterPlants', 'refreshPlants', 'getCtrls', 'filterDevices', 'filterTemplates', 'getAgentState', 'getPlantInfo'])
  }
}
</script>
